import * as Ord from "fp-ts/es6/Ord"
import * as Str from "fp-ts/es6/string"

export enum Sex {
  female = "female",
  male = "male",
}
export const sex: Ord.Ord<Sex> = Str.Ord
